import {
  dataModuleEntityId,
  DataModuleEntityId,
} from '@edgvr-front/data/domain';
import { Validate } from '@edgvr-front/util/validate';

export class DataModuleGetRequestDTO {
  private static validation = Validate.compile(
    DataModuleGetRequestDTO.validationSchema()
  );

  constructor(readonly data: DataModuleGetRequestDTORaw) {
    Validate.assert(DataModuleGetRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['id'],
      properties: {
        id: dataModuleEntityId,
      },
    };
  }
}

interface DataModuleGetRequestDTORaw {
  id: DataModuleEntityId;
}
